import React from 'react'
import styled from 'styled-components'
import { atlTheme } from '../../../atlTheme'

const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const Title = styled.h4`
  color: ${atlTheme.ColorHighContrast};
  font-size: ${atlTheme.FontSizeBody}px;
  margin: ${atlTheme.SpacingBase}px 0;
  font-weight: 500;
`

const Percentage = styled.h4`
  color: ${atlTheme.ColorMediumContrast};
  font-size: ${atlTheme.FontSizeBody}px;
  margin: ${atlTheme.SpacingBase}px 0;
  font-weight: 700;
`

interface ProgressBarTitleProps {
  title: string
  percentage: number
}

export const ProgressBarTitle: React.FunctionComponent<ProgressBarTitleProps> = ({ title, percentage }) => {
  return (
    <TextContainer>
      <Title>{title}</Title>
      <Percentage>{percentage + `%`}</Percentage>
    </TextContainer>
  )
}
